import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	tableCaption: {
		id: 'fastshift.organization-details.migration-plans.table-caption',
		defaultMessage: 'Migration plans for this organization',
		description: 'Accessible caption for the organization migration plans table.',
	},
	sourceColumnHeading: {
		id: 'fastshift.organization-details.migration-plans.source-column-heading',
		defaultMessage: 'Source',
		description: 'Column heading for the source Data Center instance.',
	},
	destinationColumnHeading: {
		id: 'fastshift.organization-details.migration-plans.destination-column-heading',
		defaultMessage: 'Destination',
		description: 'Column heading for the destination Data Center instance.',
	},
	statusColumnHeading: {
		id: 'fastshift.organization-details.migration-plans.status-column-heading',
		defaultMessage: 'Status',
		description: 'Column heading for the status of the migration plan.',
	},
	migrationPlanNameColumnHeading: {
		id: 'fastshift.organization-details.migration-plans.migration-plan-name-column-heading',
		defaultMessage: 'Plan name',
		description: 'Column heading for the name of the migration plan.',
	},
	migrationPlanStageColumnHeading: {
		id: 'fastshift.organization-details.migration-plans.migration-plan-stage-column-heading',
		defaultMessage: 'Stage',
		description: 'Column heading for the stage of the migration plan.',
	},
	migrationPlanElapsedTimeColumnHeading: {
		id: 'fastshift.organization-details.migration-plans.migration-plan-elapsed-time-column-heading',
		defaultMessage: 'Elapsed time',
		description: 'Column heading for the elapsed time of the migration plan.',
	},
	migrationPlanCreatedAtColumnHeading: {
		id: 'fastshift.organization-details.migration-plans.migration-plan-created-at-column-heading',
		defaultMessage: 'Created at',
		description: 'Column heading for the creation date of the migration plan.',
	},
	elapsedTimeDays: {
		id: 'fastshift.organization-details.migration-plans.elapsed-time.days',
		defaultMessage: '{value}d',
		description: 'Days part of a migration plan elapsed time, e.g. "1d" in "1d 2h 3m 4s".',
	},
	elapsedTimeHours: {
		id: 'fastshift.organization-details.migration-plans.elapsed-time.hours',
		defaultMessage: '{value}h',
		description: 'Hours part of a migration plan elapsed time, e.g. "2h" in "1d 2h 3m 4s".',
	},
	elapsedTimeMinutes: {
		id: 'fastshift.organization-details.migration-plans.elapsed-time.minutes',
		defaultMessage: '{value}m',
		description: 'Minutes part of a migration plan elapsed time, e.g. "3m" in "1d 2h 3m 4s".',
	},
	elapsedTimeSeconds: {
		id: 'fastshift.organization-details.migration-plans.elapsed-time.seconds',
		defaultMessage: '{value}s',
		description: 'Seconds part of a migration plan elapsed time, e.g. "4s" in "1d 2h 3m 4s".',
	},
	productJira: {
		id: 'fastshift.organization-details.migration-plans.product.jira',
		defaultMessage: 'Jira',
		description: 'Product label for a Jira migration plan source or destination.',
	},
	productConfluence: {
		id: 'fastshift.organization-details.migration-plans.product.confluence',
		defaultMessage: 'Confluence',
		description: 'Product label for a Confluence migration plan source or destination.',
	},
	productUnknown: {
		id: 'fastshift.organization-details.migration-plans.product.unknown',
		defaultMessage: 'Unknown product',
		description: 'Fallback product label for an unrecognized migration plan source or destination.',
	},
	statusDraft: {
		id: 'fastshift.organization-details.migration-plans.status.draft',
		defaultMessage: 'Draft',
		description: 'Status label for a draft migration plan.',
	},
	statusCheckStarting: {
		id: 'fastshift.organization-details.migration-plans.status.check-starting',
		defaultMessage: 'Check starting',
		description: 'Status label for a migration plan whose check is starting.',
	},
	statusCheckRunning: {
		id: 'fastshift.organization-details.migration-plans.status.check-running',
		defaultMessage: 'Check running',
		description: 'Status label for a migration plan with a check running.',
	},
	statusCheckFailed: {
		id: 'fastshift.organization-details.migration-plans.status.check-failed',
		defaultMessage: 'Check failed',
		description: 'Status label for a migration plan whose check failed.',
	},
	statusCheckCompleted: {
		id: 'fastshift.organization-details.migration-plans.status.check-completed',
		defaultMessage: 'Check completed',
		description: 'Status label for a migration plan whose check completed.',
	},
	statusCheckWarning: {
		id: 'fastshift.organization-details.migration-plans.status.check-warning',
		defaultMessage: 'Check warning',
		description: 'Status label for a migration plan whose check finished with warnings.',
	},
	statusStarting: {
		id: 'fastshift.organization-details.migration-plans.status.starting',
		defaultMessage: 'Starting',
		description: 'Status label for a migration plan that is starting.',
	},
	statusRunning: {
		id: 'fastshift.organization-details.migration-plans.status.running',
		defaultMessage: 'Running',
		description: 'Status label for a running migration plan.',
	},
	statusComplete: {
		id: 'fastshift.organization-details.migration-plans.status.complete',
		defaultMessage: 'Complete',
		description: 'Status label for a complete migration plan.',
	},
	statusStopped: {
		id: 'fastshift.organization-details.migration-plans.status.stopped',
		defaultMessage: 'Stopped',
		description: 'Status label for a stopped migration plan.',
	},
	statusIncomplete: {
		id: 'fastshift.organization-details.migration-plans.status.incomplete',
		defaultMessage: 'Incomplete',
		description: 'Status label for an incomplete migration plan.',
	},
	statusFailed: {
		id: 'fastshift.organization-details.migration-plans.status.failed',
		defaultMessage: 'Failed',
		description: 'Status label for a failed migration plan.',
	},
	statusArchived: {
		id: 'fastshift.organization-details.migration-plans.status.archived',
		defaultMessage: 'Archived',
		description: 'Status label for an archived migration plan.',
	},
	statusUnarchiving: {
		id: 'fastshift.organization-details.migration-plans.status.unarchiving',
		defaultMessage: 'Unarchiving',
		description: 'Status label for a migration plan that is being unarchived.',
	},
	statusUnknown: {
		id: 'fastshift.organization-details.migration-plans.status.unknown',
		defaultMessage: 'Unknown',
		description: 'Fallback status label for a migration plan with an unrecognized status.',
	},
	stageProd: {
		id: 'fastshift.organization-details.migration-plans.stage.prod',
		defaultMessage: 'Production',
		description: 'Stage label for a migration plan in the production stage.',
	},
	stageTest: {
		id: 'fastshift.organization-details.migration-plans.stage.test',
		defaultMessage: 'Test',
		description: 'Stage label for a migration plan in the test stage.',
	},
	stageUnknown: {
		id: 'fastshift.organization-details.migration-plans.stage.unknown',
		defaultMessage: 'Unknown',
		description: 'Fallback stage label for a migration plan with an unrecognized stage.',
	},
});
